import { ArrowLeft } from "lucide-react";
import { COMPANY } from "@/data";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] font-sans text-slate-900" data-testid="impressum-page">
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24">
        <a href="/" data-testid="impressum-back-link" className="inline-flex items-center gap-2 text-sm font-medium text-sky-700 hover:text-sky-800">
          <ArrowLeft className="h-4 w-4" /> Zurück zur Startseite
        </a>
        <p className="mt-10 font-mono text-xs uppercase tracking-[0.25em] text-sky-800">Rechtliches</p>
        <h1 className="mt-3 font-serif text-4xl font-semibold tracking-tight sm:text-5xl">Impressum</h1>

        <div className="mt-10 space-y-8 text-sm leading-relaxed text-slate-600 sm:text-base">
          <section>
            <h2 className="font-serif text-xl font-medium text-slate-900">Angaben gemäß § 5 DDG</h2>
            <p className="mt-3">
              {COMPANY.fullName}<br />
              Inhaber: {COMPANY.owner} ({COMPANY.legalForm})<br />
              {COMPANY.street}<br />
              {COMPANY.city}
            </p>
          </section>
          <section>
            <h2 className="font-serif text-xl font-medium text-slate-900">Kontakt</h2>
            <p className="mt-3">
              Telefon: <a href={COMPANY.phoneHref} className="text-sky-700 hover:underline">{COMPANY.phone}</a><br />
              E-Mail: <a href={COMPANY.emailHref} className="text-sky-700 hover:underline">{COMPANY.email}</a>
            </p>
          </section>
          <section>
            <h2 className="font-serif text-xl font-medium text-slate-900">Umsatzsteuer</h2>
            <p className="mt-3">
              Gemäß § 19 UStG (Kleinunternehmerregelung) wird keine Umsatzsteuer berechnet; eine
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a UStG liegt daher nicht vor.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-xl font-medium text-slate-900">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <p className="mt-3">
              {COMPANY.owner}<br />
              {COMPANY.street}, {COMPANY.city}
            </p>
          </section>
          <section>
            <h2 className="font-serif text-xl font-medium text-slate-900">Haftung für Inhalte</h2>
            <p className="mt-3">
              Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und
              Aktualität der Inhalte wird jedoch keine Gewähr übernommen. Alle Preisangaben auf dieser Website sind
              unverbindliche Richtwerte; verbindlich ist ausschließlich das individuell erstellte Angebot.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
